import { HotTour } from 'shared/api/tours/search'

export const filterHotTours = (hotTours: HotTour[], tabName: string) => {
  return hotTours.filter((tour) => tour.departurecode === Number(tabName))
}
